export const locale = {
    lang: 'es',
    data: {
        'SAMPLE': {
            'HELLO': '¡Hola Mundo!'
        }
    }
};
